module.exports = __webpack_public_path__ + "img/brain_black.57c3f96d.svg";